import type { ReactNode } from "react";
import { TopNav } from "./TopNav.js";
import { Footer } from "./Footer.js";

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="bg-background text-on-background min-h-screen flex flex-col scrollbar-custom">
      <TopNav />
      <main className="flex-grow p-margin-page max-w-[1600px] mx-auto w-full">{children}</main>
      <Footer />
    </div>
  );
}
